import EnhancedAdExamples from './EnhancedAdExamples/EnhancedAdExamples';

const EnhancedAdExamplesDirective = (
  reactDirective,
  CreativeService,
  CurrentUserService
) => {
  return reactDirective(
    EnhancedAdExamples,
    undefined,
    { restrict: 'E' },
    { CreativeService, CurrentUserService }
  );
};

EnhancedAdExamplesDirective.$inject = [
  'reactDirective',
  'CreativeService',
  'CurrentUserService'
];

export default EnhancedAdExamplesDirective;
